if (!customElements.get('cart-bar')) {
	class CartBar extends HTMLElement {
		connectedCallback() {
			this.wordingNode = this.querySelector('.cart-bar__text');
			this.levelNodes = this.querySelectorAll('[level]');
			this.mappedThresholds = this.thresholds.map((threshold, index) => {
				return {
					threshold: threshold * 100,
					mappedThreshold: Math.min((index + 1) / (this.thresholds.length + 1), 1),
				};
			});
			this.mappedThresholds.unshift({ threshold: 0, mappedThreshold: 0 });
		}
		get allLevelReachedText() {
			return this.getAttribute('all-levels-reached-text');
		}
		get threshold() {
			return parseFloat(this.getAttribute('threshold'));
		}
		get offset() {
			return this.hasAttribute('offset') ? parseFloat(this.getAttribute('offset')) : 0;
		}
		get thresholds() {
			return this.hasAttribute('sorted-thresholds') ? JSON.parse(this.getAttribute('sorted-thresholds')) : [];
		}
		set wording(value) {
			this.wordingNode.innerHTML = value;
		}
		calcProgress(totalPrice) {
			const activeThreshold = this.mappedThresholds.filter(
				(mappedThreshold) => totalPrice >= mappedThreshold.threshold,
			);
			const start = activeThreshold[activeThreshold.length - 1];
			const end = this.mappedThresholds.find((mappedThreshold) => totalPrice < mappedThreshold.threshold);
			if (!end) {
				return 1;
			}
			const progressBetweenMappedValues = (totalPrice - start.threshold) / (end.threshold - start.threshold);
			return (end.mappedThreshold - start.mappedThreshold) * progressBetweenMappedValues + start.mappedThreshold;
		}
		update(totalPrice, cartItems, skipAddingGifts = false) {
			this.updateProgressBar(totalPrice);
			this.updateText(totalPrice);
			this.updateActiveLevels(totalPrice);
			skipAddingGifts || this.updateCartGifts(totalPrice, cartItems);
		}
		updateProgressBar(totalPrice) {
			this.style.setProperty('--progress', this.calcProgress(totalPrice));
		}
		updateText(totalPrice) {
			if (!window.barLevels) return;
			const nextLevel = window.barLevels
				.sort((a, b) => a.threshold - b.threshold)
				.find((level) => totalPrice < level.threshold);
			if (nextLevel) {
				const remaining = theme.Currency.formatMoney(nextLevel.threshold - totalPrice, theme.settings.moneyFormat);
				this.wording = nextLevel.remainingText.replace('xx', remaining);
			} else {
				this.wording = this.allLevelReachedText;
			}
		}
		updateActiveLevels(totalPrice) {
			this.levelNodes.forEach((levelNode) => {
				const level = parseInt(levelNode.getAttribute('level'));
				const isActive = totalPrice >= level;
				levelNode.classList.toggle('active', isActive);
			});
		}
		updateCartGifts(totalPrice, cartItems) {
			if (!window.giftLevels) return;
			const updates = {};
			window.giftLevels.forEach((giftLevel) => {
				const isGiftLevelActive = totalPrice >= giftLevel.threshold;
				const giftAlreadyInCart = cartItems.some((variantId) => variantId === giftLevel.giftId);
				if (!isGiftLevelActive && giftAlreadyInCart) {
					updates[giftLevel.giftId] = 0;
				} else if (isGiftLevelActive && !giftAlreadyInCart) {
					updates[giftLevel.giftId] = 1;
				}
			});
			if (Object.keys(updates).length > 0) {
				const data = {
					updates: updates,
				};
				fetch(theme.routes.cartUpdateUrl, {
					body: JSON.stringify(data),
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
				}).then((response) => {
					if (response.ok) {
						document.dispatchEvent(new CustomEvent('cart:build'));
					}
				});
			}
		}
	}
	window.customElements.define('cart-bar', CartBar);
}
